import Icon from "@mui/icons-material/Settings";
import FmbThaliSettingsList from "./FmbThaliSettingsList";

export default {
  list: FmbThaliSettingsList,
  icon: Icon,
  label: "Thali settings",
  options: { label: "Thali settings" },
  name: "fmbThaliSettings",
};
